// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3QrVx","consentsList":"PatientConsents_consentsList__2o2nP","consentsListEmpty":"PatientConsents_consentsListEmpty__3MKw3"};